module.exports = __webpack_public_path__ + "static/media/icon_45.3eb7dfbc.svg";